import { useEffect, useState } from 'react';
import { Gateway } from '../../../../shared/api/gateway/Gateway';

import { EmailSuggestionStore } from './EmailSuggestionStore';

export const useCreateEmailSuggestionStore = () => {
	// would have prefered to use useMemo, but it needs to be created on mount
	// because the Gateway uses the ApiClient which uses Auth.configure from aws-amplify/auth
	// Auth.configure calls setState, which creates the folowing error:
	// warning: Cannot update a component (`observerComponent`) while rendering a different component (`NewBookingDetailsPage`)
	const [store, setStore] = useState<EmailSuggestionStore | undefined>();
	useEffect(() => {
		const gateway = new Gateway();
		const emailSuggestionStore = new EmailSuggestionStore(
			gateway.emailSuggestion(),
		);
		setStore(emailSuggestionStore);
	}, []);

	return store;
};
